export default __webpack_public_path__ + "static/media/bg.8b905049.webp";